export const envVars = {
	api: {
		headers: {
			accept: '%%%REACT_APP_API_HEADER_ACCEPT%%%',
			contentType: '%%%REACT_APP_API_HEADER_CONTENT_TYPE%%%',
		},
		url: '%%%REACT_APP_API_URL%%%',
	},
	contactButton: {
		bcp: '%%%REACT_APP_CONTACT_BUTTON_URL_BCP%%%',
		ab: '%%%REACT_APP_CONTACT_BUTTON_URL_AB%%%',
	},
	info: {
		buildNumber: '%%%REACT_APP_BUILD_NUMBER%%%',
		publicUrl: '%%%PUBLIC_URL%%%',
	},
	logger: {
		debug: '%%%REACT_APP_LOGGER_DEBUG%%%',
		error: '%%%REACT_APP_LOGGER_ERROR%%%',
		log: '%%%REACT_APP_LOGGER_LOG%%%',
	},
};
